import {
	OPTION_COLOR_THEMES,
	GREY_META,
	OPTION_COLOR_THEMES_MAP,
	OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT,
	OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT,
} from '../constants.tsx';

export const getRandomColor = ({ colorPaletteVariant = '' } = {}) => {
	// usign colorPaletteVariant to determine which color palette to use for random color selection
	const palette =
		colorPaletteVariant === 'newDarker'
			? OPTION_COLOR_THEMES_COLORFUL_DARKER_SINGLE_SELECT
			: OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT;

	const randomIndex = Math.floor(Math.random() * palette.length);
	return palette[randomIndex].name;
};

export const getColorNameFromValue = (colorValue: string, colorCardVariant = 'fill'): string => {
	if (colorCardVariant === 'outline') {
		return OPTION_COLOR_THEMES.find((item) => item.borderColor === colorValue)?.name ?? '';
	}
	return OPTION_COLOR_THEMES.find((item) => item.backgroundColor === colorValue)?.name ?? '';
};

export const getValueFromColorName = (colorName: string, colorCardVariant = 'fill'): string => {
	if (colorCardVariant === 'outline') {
		return OPTION_COLOR_THEMES_MAP[colorName]?.borderColor ?? '';
	}
	return OPTION_COLOR_THEMES_MAP[colorName]?.backgroundColor ?? '';
};

export const getColorMetadata = (colorName: string | null | undefined) => {
	if (!colorName) {
		return GREY_META;
	}
	return OPTION_COLOR_THEMES_MAP[colorName] ?? GREY_META;
};

export const getAllColorNames = () => OPTION_COLOR_THEMES.map((item) => item.name);
